import { entities } from "sbtech-sports-data-api-client";
import { Selection } from "../../data";
import { UIPreferences } from "..";

export class SelectionParser {
    private static _instance: SelectionParser;

    public static get instance(): SelectionParser {
        if (!SelectionParser._instance) {
            SelectionParser._instance = new SelectionParser();
        }
        return SelectionParser._instance;
    }

    public parse(selection: entities.Selection, existingSelection: Selection | undefined, uiPreferences: UIPreferences): Selection {

        return new Selection({
            id: selection.id,
            title: existingSelection ? existingSelection.title : selection.name,
            displayOdds: selection.displayOdds,
            odds: selection.displayOdds[uiPreferences.oddStyle],
            lineGroupId: existingSelection ? existingSelection.lineGroupId : selection.group.toString(),
            outcomeType: this.getOutcomeType(existingSelection ? existingSelection.outcomeType : selection.outcomeType, uiPreferences.isSwapped),
            points: existingSelection ? existingSelection.points : (selection.points ? selection.points : 0),
            isDisabled: selection.isDisabled,
            isSelected: false,
            isSwapped: uiPreferences.isSwapped,
            sbtechId: selection.metadata.idSBTech,
        });
    }

    public getOddsForOddStyle(selection: Selection, oddStyle: string): string {
        return selection.displayOdds[oddStyle];
    }

    private getOutcomeType(outcomeType: string | entities.OutcomeType | null, isSwapped: boolean): string {
        if (outcomeType === entities.OutcomeType.Home) {
            return isSwapped
                ? entities.OutcomeType.Away
                : entities.OutcomeType.Home;
        } else if (outcomeType === entities.OutcomeType.Away) {
            return isSwapped
                ? entities.OutcomeType.Home
                : entities.OutcomeType.Away;
        }
        return outcomeType ? outcomeType.toString() : "";
    }
}
